import axios from 'axios';
import logger from './logger';

const API_URL = process.env.REACT_APP_BACKEND_URL || '';

const getCountry = () => {
  try {
    return localStorage.getItem('shopperden_country') || null;
  } catch (err) { logger.error('Analytics: localStorage unavailable:', err); return null; }
};

export const trackEvent = (event, page = null, metadata = {}) => {
  try {
    axios.post(`${API_URL}/api/analytics/track`, {
      event,
      page: page || window.location.pathname,
      country: getCountry(),
      metadata
    }).catch(() => {});
  } catch (err) { logger.error('Analytics: tracking failed:', err); }
};

export const trackPageView = (page) => {
  trackEvent('page_view', page || window.location.pathname);
  // Meta Pixel SPA route-change tracking
  try {
    if (typeof window !== 'undefined' && typeof window.fbq === 'function') {
      window.fbq('track', 'PageView');
    }
  } catch (err) { logger.error('Meta Pixel pageview failed:', err); }
};

// Meta Pixel conversion helper — fires standard fb events alongside our analytics.
// Standard events: 'CompleteRegistration', 'Lead', 'Purchase', 'Subscribe', 'Contact', 'ViewContent', 'Search'
export const trackMetaEvent = (eventName, params = {}) => {
  try {
    if (typeof window !== 'undefined' && typeof window.fbq === 'function') {
      window.fbq('track', eventName, params);
    }
  } catch (err) { logger.error('Meta Pixel event failed:', err); }
};
